export const OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT = {
    DEFAULT_DEVELOPER_LABEL: "deweloper",
    getNoParkingPlacesText: (investorOrVendorName: string) => `Dla przyszłych właścicieli ${investorOrVendorName} nie przewidział miejsc postojowych.`,
    getParkingPlacesHeader: (investorOrVendorName: string) => `Dla przyszłych właścicieli ${investorOrVendorName} przewidział:`
} as const;
export const OFFER_GENERATED_DESCRIPTION_COMMERCIAL_CONTENT = {
    DEFAULT_DEVELOPER_LABEL: "deweloper",
    getNoParkingPlacesText: (investorOrVendorName: string) => `Dla przyszłych właścicieli ${investorOrVendorName} nie przewidział miejsc postojowych.`,
    getParkingPlacesHeader: (investorOrVendorName: string) => `Dla przyszłych właścicieli ${investorOrVendorName} przewidział:`
} as const;
